import {image, chart} from "../mathematics/writer";
import {addMath, setRadioState} from "../mathematics/methods";

export function addImage(row, column, url, page){
	this.setCellValue(row, column, image(url), page);
	if(!page || page == this.getActiveSheet())
		this.refresh();
}

export function addSparkline(row, column, config, page){
	let value = chart(config);
	this.setCellValue(row, column, value, page);
	if(!page || page == this.getActiveSheet())
		this.refresh();
}

// getSheetData is deprecated, use ss.getCellValue(row, col, math, page), ss.getRangeValue(range, page) instead
export function getSheetData(name){
	if(this._mData.getPage(name))
		return {
			getValue: (r, c, math)=> this.getCellValue(r, c, math, name),
			getRangeValue: (range)=> this.getRangeValue(range, name)
		};
}

export function registerMathMethod(name, handler, category, generateHTML){
	addMath(this, name, handler, true, category, generateHTML);
}

export function recalculate(){
	this._mData.getStore().recalculate();
	this.callEvent("onMathRefresh",[]);
	this.refresh();
}

export function setPlaceholder(name, value){
	if(typeof name == "object"){
		value = name;
		name = "*";
	}

	this._mData.getStore().setPlaceholder(name, value);

	this.refresh();
	this.callEvent("onMathRefresh",[]);
}

export function addCheckbox(range, page){
	if(!range){
		const areas = this._table.getAllSelectAreas();
		this.groupUndo(()=>{
			for(let name in areas)
				this.addCheckbox(areas[name], page);
		});
	}
	else if(range){
		const start = range.start;
		const end = range.end;
		this.groupUndo(()=>{
			for(let r = start.row; r <= end.row; r++)
				for(let c = start.column; c <= end.column; c++)
					this.setCellValue(r, c, "=checkbox()", page);
		});
		this.refresh();
	}
}

export function markCheckbox(row, column, state, page){
	if(/^=(checkbox)\(/i.test(this.getCellValue(row, column, true, page))){
		this.setCellValue(row, column, `=checkbox(${state === false ? 0 : 1})`);
		this.refresh();
	}
}

export function addRadio(range, page){
	if(!range){
		const areas = this._table.getAllSelectAreas();
		this.groupUndo(()=>{
			for(let name in areas)
				this.addRadio(areas[name], page);
		});
	}
	else if(range){
		const start = range.start;
		const end = range.end;
		this.groupUndo(()=>{
			for(let r = start.row; r <= end.row; r++)
				for(let c = start.column; c <= end.column; c++)
					this.setCellValue(r, c, `=radio(${r - start.row + 1}, ${c - start.column + 1}, ${end.row - start.row + 1}, ${end.column - start.column + 1})`, page);
		});
		this.refresh();
	}
}

export function markRadio(row, column, state, page){
	setRadioState(this, row, column, state, page);
}

export function calculate(math, sheet){
	const page = sheet ? this._mData.getPage(sheet) : this._mPage;
	if(math[0] === "=") math = math.slice(1);
	return this._mData.getStore().exec(math, page.getContext());
}